// Dictionary, 845 part 1 — the 845-specific segments with no shared
// equivalent: BPA (Beginning Segment for Price Authorization
// Acknowledgment/Status). Generic X12 845 (005010) definitions only; not
// tied to any trading partner's implementation guide. Sourced from
// reference/session/845-price-authorization-acknowledgment-status-qualifiers-txt.md.
//
// CON, REF, DTM, N1-N9, PER, QTY, AMT and CTP all recur inside the 845 too,
// but X12 defines one segment per id — they're already defined in
// dictionary/header-segments.ts, dictionary/item-loop-segments.ts,
// dictionary/852-item-activity-segments.ts, dictionary/844-segments.ts (CON)
// and dictionary/quantity-qualifier-codes.ts /
// dictionary/amount-qualifier-codes.ts, and merged in by index.ts, so they
// are not redefined here.

import {LoopId, type ElementDefinition, type SegmentDefinition} from './types';
import {TRANSACTION_SET_PURPOSE_CODES} from './transaction-set-purpose-codes';
import {REFERENCE_IDENTIFICATION_QUALIFIER_CODES} from './reference-identification-qualifiers';

function el(
  position: number,
  label: string,
  description: string,
  extra: Partial<ElementDefinition> = {}
): ElementDefinition {
  return {position, label, description, ...extra};
}

export const SEGMENTS_845: Record<string, SegmentDefinition> = {
  BPA: {
    id: 'BPA',
    name: 'Beginning Segment for Price Authorization Acknowledgment/Status',
    purpose:
      'Identifies what kind of price authorization this is (original, add, delete, change, replace, follow-up) and carries the authorization/SPA number and its date. Required at the start of every 845.',
    loop: LoopId.Header,
    required: true,
    elements: [
      el(
        1,
        'Transaction Set Purpose Code',
        'Whether this is an original authorization, an add, a delete, a change, a replace, or a follow-up.',
        {
          dataType: 'code',
          required: true,
          codes: TRANSACTION_SET_PURPOSE_CODES,
        }
      ),
      el(
        2,
        'Reference/Authorization Number',
        'The price authorization (SPA) number.',
        {
          required: true,
        }
      ),
      el(
        3,
        'Reference Identification Qualifier',
        'What kind of reference number follows, when one is given.',
        {
          dataType: 'code',
          codes: REFERENCE_IDENTIFICATION_QUALIFIER_CODES,
        }
      ),
      el(4, 'Date', 'Date the price authorization was prepared.', {
        dataType: 'date',
        format: 'CCYYMMDD',
        required: true,
      }),
    ],
  },
};
